import { render, staticRenderFns } from "./PurchaseInputPivotComponent.vue?vue&type=template&id=b6a34c3c&"
import script from "./PurchaseInputPivotComponent.vue?vue&type=script&lang=js&"
export * from "./PurchaseInputPivotComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports